import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, ProtectedRoute } from './contexts/AuthContext'
import { MainLayout } from './layouts/MainLayout'
import { LoginPage, PasswordResetPage } from './screens/LoginPage'
import { InvoicesPage } from './screens/InvoicesPage'
import { ReviewPage } from './screens/ReviewPage'
import { DashboardPage } from './screens/Dashboard/DashboardPage'
import { ProcessedFilesPage } from './components/ProcessedFilesPage'
import { ClientManager } from './components/ClientManager'
import { ReconciliationV2Page } from './screens/ReconciliationV2'
import { FileExplorerPage } from './screens/FileManager/FileExplorerPage'
import { TaxRequestsPage } from './screens/FileManager/TaxRequestsPage'
import { Generate } from './screens/Generate/Generate'
import { Toaster } from './components/ui/toaster'
import { TooltipProvider } from './components/ui/tooltip'
import { initializeReviewSessions } from './lib/reviewSessions'

export { useAuth } from './contexts/AuthContext'

function App() {
  useEffect(() => {
    initializeReviewSessions()
  }, [])

  return (
    <AuthProvider>
      <TooltipProvider delayDuration={300}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<PasswordResetPage />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          } />
          <Route path="/invoices/dashboard" element={<Navigate to="/dashboard" replace />} />

          <Route path="/invoices/processing" element={
            <ProtectedRoute>
              <MainLayout>
                <InvoicesPage />
              </MainLayout>
            </ProtectedRoute>
          } />

          <Route path="/clients" element={
            <ProtectedRoute>
              <MainLayout>
                <div className="page-shell">
                  <ClientManager onClientSelect={(id) => console.log('Selected client:', id)} />
                </div>
              </MainLayout>
            </ProtectedRoute>
          } />

          <Route path="/reports/:conversationId?" element={
            <ProtectedRoute>
              <MainLayout>
                <Generate />
              </MainLayout>
            </ProtectedRoute>
          } />

          <Route path="/reconciliation" element={
            <ProtectedRoute>
              <MainLayout>
                <ReconciliationV2Page />
              </MainLayout>
            </ProtectedRoute>
          } />

          <Route path="/reconciliation-v2" element={<Navigate to="/reconciliation" replace />} />

          <Route path="/reconciliation/files" element={
            <ProtectedRoute>
              <MainLayout>
                <ProcessedFilesPage />
              </MainLayout>
            </ProtectedRoute>
          } />

          <Route path="/files" element={
            <ProtectedRoute>
              <MainLayout>
                <div className="page-shell">
                  <FileExplorerPage />
                </div>
              </MainLayout>
            </ProtectedRoute>
          } />

          <Route path="/tax-requests" element={
            <ProtectedRoute>
              <MainLayout>
                <div className="page-shell">
                  <TaxRequestsPage />
                </div>
              </MainLayout>
            </ProtectedRoute>
          } />

          <Route path="/review/:invoiceId?" element={
            <ProtectedRoute>
              <MainLayout>
                <ReviewPage />
              </MainLayout>
            </ProtectedRoute>
          } />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster />
      </TooltipProvider>
    </AuthProvider>
  )
}

export default App
